import { render, staticRenderFns } from "./PreLoader.vue?vue&type=template&id=5fcf6d5b&scoped=true"
import script from "./PreLoader.vue?vue&type=script&lang=js"
export * from "./PreLoader.vue?vue&type=script&lang=js"
import style0 from "./PreLoader.vue?vue&type=style&index=0&id=5fcf6d5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcf6d5b",
  null
  
)

export default component.exports